import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";
import Loading from "../components/Loading";
import { useCreateToolProfileMutation, useListToolProfilesQuery } from "../features/model/toolprofileSlice";
import { Link as RouterLink} from "react-router-dom";
import { useState } from "react";

const NewToolProfileDialog = () => {
  let [newDialogState, setNewDialogState] = useState(false)
  let [newProfileNameState, setNewProfileNameState] = useState("")
  const [createToolProfile] = useCreateToolProfileMutation();

  const handleNewButton = () => {
    setNewDialogState(true)
  }

  const handleCancelButton = () => {
    setNewDialogState(false)
  }

  const saveNewProfile = () => {
    console.log("Need to save this guy")
    createToolProfile({name: newProfileNameState})
    setNewDialogState(false)
    setNewProfileNameState("")
  }

  const handleNameChange = (event) => {
    setNewProfileNameState(event.target.value)
  }

  return <>
    <Button variant="contained" onClick={handleNewButton}><Typography noWrap>New</Typography></Button>
    <Dialog open={newDialogState} aria-labelledby="new-profile-dialog-title" aria-describedby="new-profile-dialog-description">
      <DialogTitle id="new-profile-dialog-title">
        {"New Tool Profile"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="new-profile-dialog-description">
          Enter the name of the new tool profile
        </DialogContentText>
        <TextField autoFocus required id="name" name="name" label="Profile Name" value={newProfileNameState} onChange={handleNameChange}/>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancelButton}>
          Cancel
        </Button>
        <Button onClick={saveNewProfile} autoFocus>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  </>
}

const ToolProfileHeader = () => {

  return <TableHead>
    <TableRow>
      <TableCell>Name</TableCell>
      <TableCell>Main</TableCell>
      <TableCell>Profile</TableCell>
      <TableCell>Usage</TableCell>
      <TableCell>{NewToolProfileDialog()}</TableCell>
    </TableRow>
  </TableHead>;

}


const ToolProfileRow = (object) => {

  const makeLinkObject = (object) => {
    return `/toolprofiles/${object.id}`
  }

  const makeEditLinkObject = (object) => {
    return `/toolprofiles/${object.id}/edit`
  }

  let usage = JSON.parse(object.toolProfile.usage)
  var usageText = Object.keys(usage).map(key => {return usage[key].enabled ? key : ""}).filter(s => {return s !== "";}).join(", ");

  return <TableRow key={object.toolProfile.id}>
    <TableCell><Typography noWrap>{object.toolProfile.name}</Typography></TableCell>
    <TableCell><Checkbox checked={object.toolProfile.main} disabled></Checkbox></TableCell>
    <TableCell><img key="image" src={`data:image/svg+xml;utf8,${encodeURIComponent(object.toolProfile.svg)}`} alt="Preview" style={{width: "24px", height: "24px", borderRadius: 4}} /></TableCell>
    <TableCell>{usageText}</TableCell>
    <TableCell><Button variant="outlined" component={RouterLink} to={makeEditLinkObject(object.toolProfile)}><Typography noWrap>Edit</Typography></Button></TableCell>
  </TableRow>;
}

const ToolProfileBrowser = () => {
  const {data: toolProfiles, error, isLoading} = useListToolProfilesQuery()
  if (isLoading) {
    console.log("is loading")
    return <Loading />
  }
  if (error) {
    return <div>Error: {error}</div>
  }

  return (
    <Stack sx={{marginTop: 2}} spacing={1}>
      <Typography variant="h1">Tool Profiles</Typography>
      <TableContainer component={Paper}>
        <Table>
          <ToolProfileHeader />
          <TableBody>
            {
              toolProfiles.objects.slice().sort((a, b) => a.name.localeCompare(b.name)).map((tp, i) => <ToolProfileRow key={i} toolProfile={tp} />)
            }
          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
  );
}

export default ToolProfileBrowser;